// extracted by mini-css-extract-plugin
export default {"exclusiones__list":"ExclusionesList_exclusiones__list__6ul97"};